import { API_CLASSIFIER_URL } from "./const";

export function classifierApiUrl() {
  const classifierAPiUrl = !!process.env.REACT_APP_CLASSIFIER_API_URL && process.env.REACT_APP_CLASSIFIER_API_URL !== "" ? process.env.REACT_APP_CLASSIFIER_API_URL : "";
  if (classifierAPiUrl) {
    return classifierAPiUrl;
  }
  return API_CLASSIFIER_URL;
}

export const getClassifierApiUrl = (path) => {
  return `${classifierApiUrl()}/${path}`;
};
